export default function KnowledgeSection() {
  return (
    <section className="qs g" id="s2">
      <div className="wrap">
        <div className="qhd pd-rv">
          <div>
            <span className="ey">
              <b>02</b>
              지식 파이프라인
            </span>
            <small>여러 곳에 있는 데이터를 AI가 참고할 지식으로</small>
            <h2>
              데이터 연결과
              {' '}
              <em>지식베이스 구축</em>
            </h2>
          </div>
        </div>
        <div className="qpv pd-rv">
          <div className="col">
            <div className="lb">INPUT</div>
            <div className="qsrc">
              <span className="ico" style={{ background: "#FDECEC", color: "#E5484D", fontSize: "10px", fontWeight: "800" }}>
                PDF
              </span>
              <div>
                파일
                <small>업무 데이터를 연결</small>
              </div>
            </div>
            <div className="qsrc">
              <span className="ico" style={{ background: "var(--blu)" }}>
                <svg className="i">
                  <use href="#globe" />
                </svg>
              </span>
              <div>
                웹
                <small>웹 주소·범위 지정</small>
              </div>
            </div>
            <div className="qsrc">
              <span className="ico" style={{ background: "var(--org)" }}>
                <svg className="i">
                  <use href="#db" />
                </svg>
              </span>
              <div>
                DB
                <small>MySQL · PostgreSQL</small>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="lb">PROCESS</div>
            <div className="qtrack">
              <h4>지식베이스를 만드는 7단계</h4>
              <p>소스 선택 · 데이터 소스 · 전처리 · 청킹 · 임베딩 · 검색 설정 · 확인</p>
              <div className="qsteps">
                <span className="bar" />
                <div>
                  <i>
                    <svg className="i">
                      <use href="#globe" />
                    </svg>
                    <em>01</em>
                  </i>
                  <span>소스 선택</span>
                </div>
                <div>
                  <i>
                    <svg className="i">
                      <use href="#link" />
                    </svg>
                    <em>02</em>
                  </i>
                  <span>데이터 소스</span>
                </div>
                <div>
                  <i>
                    <svg className="i">
                      <use href="#filter" />
                    </svg>
                    <em>03</em>
                  </i>
                  <span>전처리</span>
                </div>
                <div>
                  <i>
                    <svg className="i">
                      <use href="#grid" />
                    </svg>
                    <em>04</em>
                  </i>
                  <span>청킹</span>
                </div>
                <div>
                  <i>
                    <svg className="i">
                      <use href="#cube" />
                    </svg>
                    <em>05</em>
                  </i>
                  <span>임베딩</span>
                </div>
                <div>
                  <i>
                    <svg className="i">
                      <use href="#search" />
                    </svg>
                    <em>06</em>
                  </i>
                  <span>검색 설정</span>
                </div>
                <div>
                  <i>
                    <svg className="i">
                      <use href="#flag" />
                    </svg>
                    <em>07</em>
                  </i>
                  <span>확인</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="lb">RESULT</div>
            <div className="qkb">
              <div className="hd">
                <span className="ico">
                  <svg className="i">
                    <use href="#book" />
                  </svg>
                </span>
                <div>
                  검색 가능한 지식베이스
                  <small>AI 검색과 답변에 활용</small>
                </div>
              </div>
              <div className="rw">
                사내 규정 KB
                <span className="bdg g">검색 가능</span>
              </div>
              <div className="rw">
                데이터 소스
                <b>파일 · 웹 · DB</b>
              </div>
            </div>
          </div>
        </div>
        <div className="qsub pd-rv">데이터 수집 및 지식베이스 구축</div>
        <div className="qc3">
          <div className="qcd pd-rv">
            <div className="il p">
              <span className="ft" style={{ left: "28px", top: "40px", color: "#E5484D" }}>PDF</span>
              <span className="ft" style={{ left: "84px", top: "52px", color: "#2563EB", transform: "rotate(4deg)" }}>
                TXT
              </span>
              <span className="ft" style={{ left: "140px", top: "38px", color: "#191F28", transform: "rotate(-3deg)" }}>
                MD
              </span>
              <span className="ft" style={{ left: "196px", top: "50px", color: "#16A34A", transform: "rotate(3deg)" }}>
                XLS
              </span>
              <div className="mk" style={{ left: "28px", right: "28px", bottom: "18px" }}>
                <div className="r">
                  <span className="mini-ic w">
                    <img src="/site/logos/google-drive.svg" alt="" />
                  </span>
                  Google Drive에서 가져오기
                  <span className="bdg g">연결</span>
                </div>
              </div>
            </div>
            <h4>파일에서 데이터 수집</h4>
            <p>문서·표·이미지를 AI가 참고할 지식으로 만듭니다.</p>
            <ul>
              <li>
                <svg className="i">
                  <use href="#ccheck" />
                </svg>
                PDF·TXT·Markdown·Excel 파일 지원
              </li>
              <li>
                <svg className="i">
                  <use href="#ccheck" />
                </svg>
                내 컴퓨터·Google Drive에서 수집
              </li>
            </ul>
          </div>
          <div className="qcd pd-rv">
            <div className="il s">
              <div className="mk" style={{ left: "24px", right: "24px", top: "28px" }}>
                <div className="r">
                  <span className="mini-ic" style={{ background: "#2563EB" }}>
                    <svg className="i">
                      <use href="#globe" />
                    </svg>
                  </span>
                  <span style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: "11px", color: "var(--t3)" }}>
                    https://intranet.company.com
                  </span>
                </div>
              </div>
              <div className="mk" style={{ left: "24px", width: "150px", top: "92px" }}>
                <div className="r">
                  <span className="mini-ic" style={{ background: "var(--org)" }}>
                    <svg className="i">
                      <use href="#clock" />
                    </svg>
                  </span>
                  수집 주기
                  <em>매일</em>
                </div>
              </div>
              <div className="mk" style={{ right: "24px", width: "120px", top: "108px" }}>
                <div className="r">
                  <span className="mini-ic" style={{ background: "var(--grn)" }}>
                    <svg className="i">
                      <use href="#repeat" />
                    </svg>
                  </span>
                  자동 갱신
                </div>
              </div>
            </div>
            <h4>웹에서 필요한 정보 수집</h4>
            <p>필요한 웹 정보를 모아 AI 지식으로 활용합니다.</p>
            <ul>
              <li>
                <svg className="i">
                  <use href="#ccheck" />
                </svg>
                수집할 웹 주소와 범위 지정
              </li>
              <li>
                <svg className="i">
                  <use href="#ccheck" />
                </svg>
                정해진 주기에 따라 데이터 자동 갱신
              </li>
            </ul>
          </div>
          <div className="qcd pd-rv">
            <div className="il o">
              <div className="mk" style={{ left: "24px", right: "24px", top: "22px" }}>
                <div className="hd">
                  데이터베이스 연결
                  <span className="bdg o">2</span>
                </div>
                <div className="r">
                  <span className="mini-ic" style={{ background: "#0E7490" }}>
                    <svg className="i">
                      <use href="#db" />
                    </svg>
                  </span>
                  MySQL
                  <span className="bdg g">연결됨</span>
                </div>
                <div className="r">
                  <span className="mini-ic" style={{ background: "#1D4ED8" }}>
                    <svg className="i">
                      <use href="#db" />
                    </svg>
                  </span>
                  PostgreSQL
                  <span className="bdg g">연결됨</span>
                </div>
              </div>
            </div>
            <h4>업무에 맞는 DB 연결</h4>
            <p>운영 중인 데이터베이스를 연결해 업무 데이터를 활용합니다.</p>
            <ul>
              <li>
                <svg className="i">
                  <use href="#ccheck" />
                </svg>
                MySQL·PostgreSQL 등 주요 DB 연결
              </li>
              <li>
                <svg className="i">
                  <use href="#ccheck" />
                </svg>
                문서 검색·답변 또는 자연어 데이터 조회
              </li>
            </ul>
          </div>
        </div>
        <div className="qsub pd-rv">데이터 전처리 및 검색 설정</div>
        <div className="qc3">
          <div className="qcd pd-rv">
            <div className="il t">
              <div className="mk" style={{ left: "24px", right: "24px", top: "22px", padding: "14px", display: "flex", flexDirection: "column", gap: "8px" }}>
                <div style={{ display: "flex", gap: "8px", alignItems: "center", fontSize: "12px", fontWeight: "700" }}>
                  <span className="ft" style={{ position: "static", width: "30px", height: "36px", fontSize: "8px", paddingBottom: "5px", color: "#E5484D", boxShadow: "0 0 0 1px var(--g2)" }}>
                    PDF
                  </span>
                  사내 업무 매뉴얼
                  <span className="bdg p" style={{ marginLeft: "auto" }}>추출 중</span>
                </div>
                <span className="sk" style={{ width: "92%", background: "#DCD9FA" }} />
                <span className="sk" style={{ width: "78%" }} />
                <span className="sk" style={{ width: "60%", opacity: ".45", position: "relative" }} />
                <span className="sk" style={{ width: "84%", background: "#DCD9FA" }} />
              </div>
            </div>
            <h4>파일에서 내용 추출·정리</h4>
            <p>파일의 내용을 읽고 검색에 필요한 정보를 정리합니다.</p>
            <ul>
              <li>
                <svg className="i">
                  <use href="#ccheck" />
                </svg>
                문서·표·이미지 내용 추출
              </li>
              <li>
                <svg className="i">
                  <use href="#ccheck" />
                </svg>
                불필요한 내용·빈 값·중복 데이터 정리
              </li>
            </ul>
          </div>
          <div className="qcd pd-rv">
            <div className="il k">
              <div style={{ position: "absolute", left: "24px", right: "24px", top: "26px", display: "flex", flexDirection: "column", gap: "8px" }}>
                <div style={{ display: "flex", gap: "8px" }}>
                  <span className="mk" style={{ position: "static", flex: "3", height: "34px", display: "flex", alignItems: "center", padding: "0 12px", fontSize: "11px", fontWeight: "700", color: "var(--ac)" }}>
                    청크 1
                  </span>
                  <span className="mk" style={{ position: "static", flex: "2", height: "34px", display: "flex", alignItems: "center", padding: "0 12px", fontSize: "11px", fontWeight: "700", color: "var(--ac)", boxShadow: "0 0 0 2px var(--ac2)" }}>
                    겹침
                  </span>
                </div>
                <div style={{ display: "flex", gap: "8px" }}>
                  <span className="mk" style={{ position: "static", flex: "2", height: "34px", display: "flex", alignItems: "center", padding: "0 12px", fontSize: "11px", fontWeight: "700", color: "var(--ac)", boxShadow: "0 0 0 2px var(--ac2)" }}>
                    겹침
                  </span>
                  <span className="mk" style={{ position: "static", flex: "3", height: "34px", display: "flex", alignItems: "center", padding: "0 12px", fontSize: "11px", fontWeight: "700", color: "var(--ac)" }}>
                    청크 2
                  </span>
                </div>
                <div className="mk" style={{ position: "static", display: "flex", alignItems: "center", gap: "8px", height: "34px", padding: "0 12px", fontSize: "11px", fontWeight: "600", color: "var(--t3)" }}>
                  분할 크기
                  <span style={{ flex: "1", height: "4px", borderRadius: "2px", background: "linear-gradient(90deg,var(--ac) 62%,var(--g2) 62%)" }} />
                </div>
              </div>
            </div>
            <h4>내용을 나누는 방식(청킹)</h4>
            <p>검색에 활용하기 좋은 크기로 데이터를 나눕니다.</p>
            <ul>
              <li>
                <svg className="i">
                  <use href="#ccheck" />
                </svg>
                데이터 특성에 맞는 분할 방식 선택
              </li>
              <li>
                <svg className="i">
                  <use href="#ccheck" />
                </svg>
                분할 크기와 내용이 겹치는 범위 조정
              </li>
            </ul>
          </div>
          <div className="qcd pd-rv">
            <div className="il y">
              <div className="mk" style={{ left: "24px", right: "24px", top: "22px" }}>
                <div className="hd">
                  임베딩 모델
                  <span className="bdg p">지식베이스별</span>
                </div>
                <div className="r">
                  <span className="mini-ic" style={{ background: "var(--ac)" }}>
                    <svg className="i">
                      <use href="#cpu" />
                    </svg>
                  </span>
                  검색 모델 선택
                  <span className="btnm o">변경</span>
                </div>
                <div className="r">
                  <span className="mini-ic" style={{ background: "var(--grn)" }}>
                    <svg className="i">
                      <use href="#coin" />
                    </svg>
                  </span>
                  예상 비용 확인
                  <em>데이터 변환</em>
                </div>
              </div>
            </div>
            <h4>지식베이스별 검색 모델 설정</h4>
            <p>지식베이스마다 검색에 사용할 임베딩 모델을 지정합니다.</p>
            <ul>
              <li>
                <svg className="i">
                  <use href="#ccheck" />
                </svg>
                선택한 모델을 모든 데이터 소스에 적용
              </li>
              <li>
                <svg className="i">
                  <use href="#ccheck" />
                </svg>
                데이터 변환에 필요한 예상 비용 확인
              </li>
            </ul>
          </div>
        </div>
        <div className="pnote pd-rv">
          <span>파일·웹·DB 데이터를 정리해, AI가 검색하고 답변에 참고할 지식베이스를 만듭니다.</span>
        </div>
      </div>
    </section>
  );
}
